/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AlertConfigurationService } from './services/alert-configuration.service';
import { AlertIncidentService } from './services/alert-incident.service';
import { AssetService } from './services/asset.service';
import { BillingService } from './services/billing.service';
import { CarService } from './services/car.service';
import { CdrService } from './services/cdr.service';
import { ChardiWeightingService } from './services/chardi-weighting.service';
import { ChargerService } from './services/charger.service';
import { ChargerGroupsService } from './services/charger-groups.service';
import { ChargerOptionsService } from './services/charger-options.service';
import { ChargerStatisticsService } from './services/charger-statistics.service';
import { ComplianceService } from './services/compliance.service';
import { ConfigurationProfileService } from './services/configuration-profile.service';
import { ConnectorService } from './services/connector.service';
import { CustomerOnboardingService } from './services/customer-onboarding.service';
import { DocumentService } from './services/document.service';
import { EmsService } from './services/ems.service';
import { ErrorStatsService } from './services/error-stats.service';
import { GridOperatorService } from './services/grid-operator.service';
import { InvoiceService } from './services/invoice.service';
import { LocationService } from './services/location.service';
import { NgChargeService } from './services/ng-charge.service';
import { NotesService } from './services/notes.service';
import { OperationsService } from './services/operations.service';
import { OperatorService } from './services/operator.service';
import { PartnerInfoService } from './services/partner-info.service';
import { RfidService } from './services/rfid.service';
import { SettingsService } from './services/settings.service';
import { SmartCarService } from './services/smart-car.service';
import { SmartCarConnectService } from './services/smart-car-connect.service';
import { SmartChargingService } from './services/smart-charging.service';
import { StripeService } from './services/stripe.service';
import { StripeWebhookService } from './services/stripe-webhook.service';
import { SubscriptionPlanService } from './services/subscription-plan.service';
import { TariffService } from './services/tariff.service';
import { TransactionService } from './services/transaction.service';
import { TriggerService } from './services/trigger.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AlertConfigurationService,
    AlertIncidentService,
    AssetService,
    BillingService,
    CarService,
    CdrService,
    ChardiWeightingService,
    ChargerService,
    ChargerGroupsService,
    ChargerOptionsService,
    ChargerStatisticsService,
    ComplianceService,
    ConfigurationProfileService,
    ConnectorService,
    CustomerOnboardingService,
    DocumentService,
    EmsService,
    ErrorStatsService,
    GridOperatorService,
    InvoiceService,
    LocationService,
    NgChargeService,
    NotesService,
    OperationsService,
    OperatorService,
    PartnerInfoService,
    RfidService,
    SettingsService,
    SmartCarService,
    SmartCarConnectService,
    SmartChargingService,
    StripeService,
    StripeWebhookService,
    SubscriptionPlanService,
    TariffService,
    TransactionService,
    TriggerService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
